import './search-info.scss';
import React, {Fragment, useCallback} from 'react';
import {Button} from 'react-bootstrap';
import {
    useSearchPageType,
    useStateLastSearchedQuery,
    useStateResultFor,
    useStateSpellCheckResult,
    useStateTotalFound,
} from '../../search-hooks';
import {useDispatch, useSelector} from 'react-redux';
import {fetchFacets, search, searchResetFacetsAction} from '../../duck/search-actions';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {useLocalizationUtil} from '../../../localizationUtil';

export const SearchInfo = React.memo(() => {
    const searchPageType = useSearchPageType();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history: History = useHistory();

    const lastSearchedQuery = useStateLastSearchedQuery();
    const spellCheckResult = useStateSpellCheckResult();
    const totalFound = useStateTotalFound() || 0;
    const resultFor = useStateResultFor();
    const retainFilterAcrossSearches = useSelector((state) => state.facetFilter.retainFilterAcrossSearches);
    const {formatNumber} = useLocalizationUtil();


    const searchInsteadFor = useCallback((searchExpression: string) => {
            if (!retainFilterAcrossSearches) {
                dispatch(searchResetFacetsAction(searchPageType));
            }
            dispatch(fetchFacets(searchPageType, searchExpression, false));
            return dispatch(search(searchPageType, history, searchExpression, undefined, false));
        },
        [searchPageType, dispatch, history, retainFilterAcrossSearches]
    );

    const onSearchInsteadFor = (query: string) => {
        searchInsteadFor(query);
    };

    const didYouMeanCmp = () => {
        let text, link;
        // if there are any resultsFor (means, a first search was triggered) create the results for link
        if (resultFor) {
            text = t('search.label.info.resultsFor');
            link = resultFor;

            // otherwise the "instead search for" link was clicked and a search without spellcheck suggestions was triggered before.
            // -> create the standard "did you mean" link
        } else {
            text = t('search.label.info.didYouMean');
            link = spellCheckResult;
        }
        return (
            <>
                <span>|</span>
                <div className="did-you-mean">
                    {text}:
                    <Button
                        variant="link"
                        className="did-you-mean-link"
                        onClick={() => onSearchInsteadFor(spellCheckResult || '')}
                    >
                        {link}
                    </Button>
                </div>
            </>
        );
    };

    const insteadSearchForCmp = () => {
        if (resultFor) {
            return (
                <>
                    <span>|</span>
                    <div id="instead-search-for" className="did-you-mean">
                        {t('search.label.info.insteadSearchFor')}:
                        <Button
                            variant="link"
                            className="did-you-mean-link"
                            onClick={() => onSearchInsteadFor(lastSearchedQuery)}
                        >
                            {lastSearchedQuery}
                        </Button>
                    </div>
                </>
            );
        }
    };

    const renderTotalDocumentsFound = () => {
        return (
            <span id={'total-products-found'}>
            {`${formatNumber(totalFound)} ${t('search.label.info.result_plural')}`}
            </span>
        );
    };

    return (
        <Fragment>
            <div id="search-info">
                {renderTotalDocumentsFound()}
                {spellCheckResult && ( // if having any results display box, otherwise nothing
                    <div className="search-suggestions-box">
                        {didYouMeanCmp()}
                        {insteadSearchForCmp()}
                    </div>
                )}
            </div>
        </Fragment>
    );
});
